import Camera from '@/utils/camera.js'

export default {
  name: 'cameraComponent',
  data() {
    return {
      camera: null,
      photosContainer: [],
      photoCount: 0,
      takingPhoto: false
    }
  },
  computed: {},
  methods: {
    async initCamera() {
      try {
        await this.camera.startCamera()
      } catch (error) {
        console.error('Error starting camera', error)
      }
    },

    stopCamera() {
      this.camera.stopCamera()
    },

    addPhoto(photo) {
      this.photosContainer.push(photo)
      this.photoCount++
      this.emitPhotosArray()
    },

    toggleTakingPhoto() {
      this.takingPhoto = !this.takingPhoto
    },

    async takePhoto() {
      if (this.takingPhoto) return

      this.toggleTakingPhoto()
      const photo = await this.camera.takePhoto()

      this.addPhoto(photo)
      this.toggleTakingPhoto()
    },
    async switchCamera() {
      const switchCamera = await this.camera.switchCamera()
      return switchCamera
    },
    async toggleFlash() {
      const toggleFlash = await this.camera.toggleFlash()
      return toggleFlash
    },
    emitPhotosArray() {
      this.$emit('photosArray', this.photosContainer)
    },

    async addPhotoFromGallery(file) {
      const photo = await this.camera.addPhotoFromGallery(file)
      this.addPhoto(photo)
    }
  },
  async mounted() {
    this.camera = new Camera(this.$refs.videoContainer)
    await this.initCamera()
  },
  beforeDestroy() {
    this.stopCamera()
  }
}
